// extracted by mini-css-extract-plugin
export var card = "_66-0";
export var expandedCard = "_66-2";
export var paginated = "_66-1";